module.exports = __webpack_public_path__ + "img/65.c7fb1ee2.svg";